import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { ChartData } from "../../../models/ChartCollectionData";
import CollectionChartArea from "../../AnalysisCollectionsComponents/CollectionChartArea";
import ModalCreateEditChart from "../../AnalysisCollectionsComponents/ModalCreateEditChart";

export interface IFacilityDetailsAnalysisProps {
  currentChartData: ChartData;
  onChooseChart: (chartData: ChartData) => void;
}

export const FacilityDetailsAnalysis = (
  props: IFacilityDetailsAnalysisProps
) => {
  const { currentChartData, onChooseChart } = props;

  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityDetailsPage.analysis.${key}`);

  const [shownModalCreateEditChart, setShownModalCreateEditChart] =
    useState<boolean>(false);

  return (
    <>
      <div className="detail-group">
        <div className="group-title">
          {t("title")}
          <div className="line"></div>
        </div>
        <div className="white-border-panel analytics-module padding32">
          {currentChartData.id !== 0 ? (
            <CollectionChartArea
              indivFacilityMode={true}
              chartData={currentChartData}
              totalLength={1}
              chartIndex={1}
              onClickEditChart={() => setShownModalCreateEditChart(true)}
            />
          ) : (
            <div className="add-chart">
              <button
                className="btn btn-border"
                onClick={() => {
                  setShownModalCreateEditChart(true);
                }}
              >
                <i className="icons icon-add"></i>
                {t("select_chart")}
              </button>
            </div>
          )}
        </div>
      </div>
      {
        // Facility Details do not have an edit mode
        shownModalCreateEditChart && (
          <ModalCreateEditChart
            indivFacilityMode={true}
            isEdit={false}
            editingChartData={currentChartData}
            onClose={() => {
              setShownModalCreateEditChart(false);
            }}
            onDelete={() => {}}
            onCreateSaveChart={(
              _labelName: string,
              selectedTemplateChart: ChartData
            ) => {
              onChooseChart(selectedTemplateChart);
              setShownModalCreateEditChart(false);
            }}
          />
        )
      }
    </>
  );
};
